import React from "react";
import { Button, Typography } from "../../core";
import ReactToPrint from "react-to-print";
import { Link } from "react-router-dom";
import LetterHead from "../../components/LetterHead";
import { connect } from "react-redux";
import styled from "styled-components";
import { MixStyle } from "../../styles";

import { Redirect } from "react-router-dom";
const TotalBillContainer = styled.div`
  max-width: 400px;
  margin: 20px 0px 0px auto;
  .b-b-2 {
    border-bottom: 2px solid #e7ecf4;
  }
  .f-between {
    ${MixStyle.flexBetween};
  }
  > div {
    padding: 15px 0px;
    > span {
      font-weight: 500;
      font-size: 16px;
      line-height: 24px;
      color: #233b67;
    }
  }
  .footer--div {
    ${MixStyle.flexBetween};
    background: #eff5fe;
    border-radius: 0px 0px 14px 14px;
  }
`;
const StyledTable = styled.table`
  border: 1px solid darkblue;
  border-spacing: 0;
  clear: both;
  margin: 2mm 0mm;
  height: 100mm;
  width: 100%;
  th,
  td {
    border-left: 1px solid darkblue;
  }
  th:first-child,
  td:first-child {
    border-left: none;
  }
  .invoice_line th:nth-child(2) {
    width: 60mm;
  }
  th {
    border-bottom: 1px solid darkblue;
  }
  td {
    vertical-align: top;
    font-size: 8pt;
  }
  th {
    text-align: center;
    font-weight: normal;
  }
  .amount {
    text-align: right;
  }
  .invoice_line {
    height: 6mm;
  }
  .invoice_line td,
  .invoice_line th {
    padding: 1mm;
  }
`;

class ComponentToPrint extends React.Component {
  state = {
    invoice: this.props.invoice,
  };

  SingleQuality = this.props.clothQualiyies
    ? this.props.clothQualiyies.filter((data) => {
        return data.cloth_quality_id === this.props.invoice.cloth_quality_id;
      })[0]
    : [];

  variant_rate =
    this.state.invoice.variant_rate.length !== 0
      ? this.state.invoice.variant_rate
      : [];

  price_without_sales_tax =
    this.variant_rate.length !== 0
      ? this.variant_rate.map((data) => data.quantity * data.rate)
      : this.state.invoice.rate_per_meter *
        this.state.invoice.net_pass_quantity;

  rate_of_sale_tax =
    this.variant_rate.length !== 0
      ? this.price_without_sales_tax.map((data, index) => {
          const calculated = (data * this.state.invoice.tax_gst) / 100;
          return calculated;
        })
      : (this.price_without_sales_tax * this.state.invoice.tax_gst) / 100;
  total_payable =
    this.variant_rate.length !== 0
      ? this.rate_of_sale_tax.map(
          (data, index) => data + this.price_without_sales_tax[index]
        )
      : this.price_without_sales_tax + this.rate_of_sale_tax;
  isEmpty(obj) {
    return Object.keys(obj).length === 0;
  }
  render() {
    if (this.isEmpty(this.state.invoice))
      return (
        <div>
          <Redirect to="/contract-list" />
        </div>
      );
    else
      return (
        <LetterHead Invoice={this.state.invoice} className="page">
          {console.log("Usama", this.props.invoice)}
          <div>
            <StyledTable>
              <colgroup>
                <col />
                <col />
                <col />
                <col />
                <col />
                <col />
                <col />
              </colgroup>
              <tr className="invoice_line">
                <th>Quantity</th>
                <th>Description</th>
                <th>Price</th>
                <th>Price without sale tax</th>
                <th>Rate of sale tax</th>
                <th>sales tax payable Rs</th>
                <th>Value include sales tax</th>
              </tr>

              {this.variant_rate.length !== 0 ? (
                this.variant_rate.map((data, index) => (
                  <tr key={index} className="invoice_line">
                    <td>
                      <div>{data.quantity}</div>
                    </td>
                    <td className="site">
                      <div>
                        {data.category}
                        <br />
                        {this.SingleQuality.reed} *{this.SingleQuality.pick} /
                        {this.warp}*{this.SingleQuality.weft} =
                        {this.SingleQuality.width}"{this.SingleQuality.type}
                        <br />
                        {this.state.invoice.invoice_note
                          ? this.state.invoice.invoice_note
                          : null}
                      </div>
                    </td>
                    <td>{data.rate}</td>
                    <td>{this.price_without_sales_tax[index]}</td>
                    <td>
                      {this.state.invoice.tax_gst
                        ? this.state.invoice.tax_gst
                        : 0}
                      %
                    </td>
                    <td>{this.rate_of_sale_tax[index]}</td>
                    <td>
                      {(data.quantity *
                        data.rate *
                        this.state.invoice.tax_gst) /
                        100 +
                        data.quantity * data.rate}
                    </td>
                  </tr>
                ))
              ) : (
                <tr className="invoice_line">
                  <td>{this.state.invoice.net_pass_quantity}</td>
                  <td>
                    {this.SingleQuality.reed} *{this.SingleQuality.pick} /
                    {this.SingleQuality.warp}*{this.SingleQuality.weft} =
                    {this.SingleQuality.width}"{this.SingleQuality.type}
                    <br />
                    {this.state.invoice.invoice_note
                      ? this.state.invoice.invoice_note
                      : null}
                  </td>

                  <td>{this.state.invoice.rate_per_meter}</td>
                  <td>
                    {this.price_without_sales_tax
                      ? this.price_without_sales_tax
                      : 0}
                  </td>
                  <td>
                    {this.state.invoice.tax_gst
                      ? this.state.invoice.tax_gst
                      : 0}
                    %
                  </td>
                  <td>{this.rate_of_sale_tax ? this.rate_of_sale_tax : 0}</td>
                  <td>{this.total_payable ? this.total_payable : 0}</td>
                </tr>
              )}
              <tr>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
              </tr>
            </StyledTable>
            <TotalBillContainer>
              <div className="f-between b-b-2">
                <Typography as="h6" noMargin color="#233B67" weight="500">
                  Sub Total Exclude Tax
                </Typography>
                <Typography as="h6" noMargin color="#404E67" weight="500">
                  Rs&nbsp;{this.state.invoice.total_price_without_sale_tax}
                </Typography>
              </div>

              <div className="f-between b-b-2">
                <span>Total Tax</span>
                <span>Rs&nbsp;{this.state.invoice.total_sale_tax_payable}</span>
              </div>

              <div className="footer--div">
                <Typography as="h6" noMargin color="#404E67" weight="500">
                  Grand Total Include Tax
                </Typography>
                <Typography as="h6" noMargin color="#404E67" weight="500">
                  Rs&nbsp;
                  <span className="themed--color_pink">
                    {this.state.invoice.total_value_include_sale_tax}
                  </span>
                </Typography>
              </div>
            </TotalBillContainer>
          </div>
        </LetterHead>
      );
  }
}

class Example extends React.Component {
  render() {
    return (
      <div>
        <div className="d-flex h-between m-20">
          <Link to="/contract-list">
            <Button width="187px" bg="#404E67">
              <Typography
                text="Back To List"
                as="h5"
                noMargin
                weight="bold"
                align="center"
                color="white"
              />
            </Button>
          </Link>

          <ReactToPrint
            trigger={() => {
              return (
                <Button
                  width="187px"
                  bg="#404E67"
                  type="primary"
                  htmlType="submit"
                  margin="0px"
                >
                  <Typography
                    text="Print"
                    as="h5"
                    noMargin
                    weight="bold"
                    align="center"
                    color="white"
                  />
                </Button>
              );
            }}
            content={() => this.componentRef}
          />
        </div>
        <ComponentToPrint
          invoice={this.props.invoice}
          clothQualiyies={this.props.clothQualiyies}
          ref={(el) => (this.componentRef = el)}
        />
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    invoice: state.previewInvoice.invoice,
    clothQualiyies: state.clothQualityReducer.clothQuality,
  };
};
// export default Example;
export default connect(mapStateToProps, null)(Example);
